package com.mps.asc_app.ui.theme

import androidx.compose.material3.Typography
import androidx.compose.runtime.Composable
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.em
import androidx.compose.ui.unit.sp
import asc_app.composeapp.generated.resources.Res
import asc_app.composeapp.generated.resources.pitagon_sans_text_400
import asc_app.composeapp.generated.resources.pitagon_sans_text_500
import asc_app.composeapp.generated.resources.pitagon_sans_text_600
import asc_app.composeapp.generated.resources.sofia_sans_semi_condensed_500
import asc_app.composeapp.generated.resources.sofia_sans_semi_condensed_600
import asc_app.composeapp.generated.resources.sofia_sans_semi_condensed_700
import org.jetbrains.compose.resources.Font

/** Ueberschriften: Sofia Sans Semi Condensed (wie die Vereinsseite). Lizenz: SIL Open Font License. */
@Composable
fun headlineFontFamily(): FontFamily = FontFamily(
    Font(Res.font.sofia_sans_semi_condensed_500, FontWeight.Medium),
    Font(Res.font.sofia_sans_semi_condensed_600, FontWeight.SemiBold),
    Font(Res.font.sofia_sans_semi_condensed_700, FontWeight.Bold),
)

/** Fliesstext und Bedienelemente: Pitagon Sans Text. Lizenz: SIL Open Font License. */
@Composable
fun textFontFamily(): FontFamily = FontFamily(
    Font(Res.font.pitagon_sans_text_400, FontWeight.Normal),
    Font(Res.font.pitagon_sans_text_500, FontWeight.Medium),
    Font(Res.font.pitagon_sans_text_600, FontWeight.SemiBold),
)

/** Typografie: Display/Headline/Title in der Ueberschriftenschrift, Body/Label in der Textschrift. */
@Composable
fun appTypography(): Typography {
    val head = headlineFontFamily()
    val text = textFontFamily()
    fun h(size: Int, weight: FontWeight = FontWeight.Bold) = TextStyle(
        fontFamily = head, fontWeight = weight, fontSize = size.sp, lineHeight = (size * 1.15).sp, letterSpacing = 0.005.em,
    )
    fun t(size: Int, weight: FontWeight = FontWeight.Normal, line: Double = 1.5) = TextStyle(
        fontFamily = text, fontWeight = weight, fontSize = size.sp, lineHeight = (size * line).sp,
    )
    return Typography(
        displayLarge = h(48),
        displayMedium = h(40),
        displaySmall = h(34),
        headlineLarge = h(30),
        headlineMedium = h(26),
        headlineSmall = h(22),
        titleLarge = h(20),
        titleMedium = t(16, FontWeight.SemiBold, 1.4),
        titleSmall = t(14, FontWeight.SemiBold, 1.4),
        bodyLarge = t(16),
        bodyMedium = t(14),
        bodySmall = t(12),
        labelLarge = t(14, FontWeight.SemiBold, 1.3),
        labelMedium = t(12, FontWeight.Medium, 1.3),
        labelSmall = t(11, FontWeight.Medium, 1.3),
    )
}
